module.exports = __webpack_public_path__ + "static/img/slide_4.561c69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/slide_4.png
// module id = Sq8x
// module chunks = 0